import { FileManaged } from '../structures/response/FileManaged';
import { AccountFileCategoryEnum } from '../enum/AccountFileCategoryEnum';
import { fileDelete, fileUpload } from '../api/file';
import { updateSubject } from '../api/user';

export default function usePassportUpload(): [
  (v: File[], subjectId: number, attachedFid: number[]) => Promise<void>,
  (id: string | number) => Promise<void>
] {
  const handleUploadFiles = async (files: File[]) => {
    const data = Array.from(files)
      .slice(0, 2)
      .map((file) => ({
        file,
        category: AccountFileCategoryEnum.PASSPORT_SCAN,
      }));
    return Promise.all(data.map((d) => fileUpload(d)));
  };

  const onFilesUploadedDefault = (passportFid: number[], subjectId: number) =>
    updateSubject({ id: subjectId, passportFid });

  const uploadFiles = async (
    files: File[],
    subjectId: number,
    attachedFid: number[] = []
  ) => {
    const uploaded = await handleUploadFiles(files);
    const fid = uploaded.map((u) => u.id);
    const passportFid = [...fid, ...attachedFid].slice(0, 2);
    return onFilesUploadedDefault(passportFid, subjectId);
  };

  const deleteFile = async (id: string | number) => fileDelete(id);

  return [uploadFiles, deleteFile];
}
